import { AxiosPostUrl } from "../../functions/axiosfunctions";

export function addNewProjet(data: Object, cb = function (reponse: any) {}) {
  // console.log(data)
  AxiosPostUrl(
    "/administration/projet/new",
    data,
    (reponse) => {
      if (reponse) {
        cb(reponse);
      } else {
        cb({
          success: false,
          data: {},
          msg: "Erreur survenue !",
        });
      }
    },
    function (reponse) {
      cb({
        success: false,
        data: {},
        msg: "Erreur survenue !",
      });
    }
  );
}
